import React from 'react';
import type { Option as FieldValue } from '@atlassian/jira-issue-field-parent-link/src/common/types.tsx';
import { DisabledEpicLinkParentLinkField } from '../../common/ui/fields/epic-link-parent-link-disabled/index.tsx';
import { FieldContainer } from '../../common/ui/fields/styled.tsx';
import { withFormField } from '../../common/ui/with-form-field/index.tsx';
import type { ParentLinkFieldConfig, Props } from './types.tsx';
import { validateParentLinkField } from './utils.tsx';

const ParentLinkField = (props: Props) => {
	const { width } = props;

	// We are disabling the Epic Link and Parent Link fields for taking input and instead displaying that the user should
	// use the Parent field to set the Parent of the issue as part of migrating to a single way of representing Jira's hierarchy.
	return (
		<FieldContainer width={width}>
			<DisabledEpicLinkParentLinkField />
		</FieldContainer>
	);
};
export default withFormField({
	validator: validateParentLinkField,
	// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<ParentLinkFieldConfig, Option>, any>'.
})<ParentLinkFieldConfig, FieldValue>(ParentLinkField);
